require('./eshop');
var $ = require('jquery');
require('./web/highslide-settings');
require('./web/jquery.webslider-inspiration');
require('./web/jquery.webslider-catalog');
require('./web/plUpload/fg.upload');
require('./web/MultipleWidgetContainer/index');
require('fg-frontend/third/jquery.cookie');
require('bootstrap/js/dist/modal');

require('intersection-observer');


// webslider
$('.js_webslider-inspiration').websliderInspiration();

$('.js_back').on('click', function(e) {
  e.preventDefault();
  window.history.back();
});

$('.js_anchors a').on('click', function(e){
  e.preventDefault();
  var targetOffset;
  $('.js_anchors li').removeClass('active');
  $(this).parents('li').addClass('active');
  targetOffset = $($(this).attr('href')).offset();
  if (typeof(targetOffset) !== 'undefined') {
    $('html,body').animate({scrollTop: targetOffset.top},'slow');
  }
});

// handling zobrazeni detailu serie
$(document).on('ASSEMBLY_DETAIL_VISITED', function(e, sourceId) {
    if($.cookie('lastVisitedSeries')) {
        var seriesArray = $.cookie('lastVisitedSeries').split('|');
        if(seriesArray.indexOf(sourceId.toString()) !== -1) {
            seriesArray.splice(seriesArray.indexOf(sourceId.toString()),1);
        }
        seriesArray = seriesArray.slice(0, 5);
        seriesArray.unshift(sourceId.toString());
        $.cookie('lastVisitedSeries', seriesArray.join('|'), { expires: 1000, path: '/' }, false);
    } else {
        $.cookie('lastVisitedSeries', sourceId.toString(), { expires: 1000, path: '/' }, false);
    }
});

// odebrani/pridani serie do wishlistu
$(document).on('ASSEMBLY_WISHLIST', function(e, sourceId, $element) {
    if($.cookie('assembliesInWishlist')) {
        var seriesArray = $.cookie('assembliesInWishlist').split('|');
        if(seriesArray.indexOf(sourceId.toString()) !== -1) { //jiz existuje (odebereme)
            seriesArray.splice(seriesArray.indexOf(sourceId.toString()),1);
            //seriesArray = seriesArray.slice();
            $element.removeClass('active');
            // $element.html($element.html().replace($element[0].innerText, $element[0].dataset.defaultTitle));
        } else { //jeste v poli neni (pridame)
            seriesArray = seriesArray.slice();
            seriesArray.unshift(sourceId.toString());
            // $element.html($element.html().replace($element[0].innerText, $element[0].dataset.activeTitle));
            $element.addClass('active');
        }
        $.cookie('assembliesInWishlist', seriesArray.join('|'), { expires: 1000, path: '/' }, false);
    } else {
        $.cookie('assembliesInWishlist', sourceId.toString(), { expires: 1000, path: '/' }, false);
        // $element.html($element.html().replace($element[0].innerText, $element[0].dataset.activeTitle));
        $element.addClass('active');
    }
});

// click na pridani serie do wishlistu
$('.js_assembly-wishlist-btn').click(function(e) {
    $(document).trigger('ASSEMBLY_WISHLIST', [$(this).data('sourceId'), $(this)]);
    var timeStamp = new Date();
    $('.js_eshop-header-wishlist').load('/qf/'+$('html').attr('lang')+'/ramjet/include@userLists?ts='+timeStamp.getTime()+' .js_eshop-header-wishlist > *');
});

// kontrola pri nacteni stranky na serii ve wishlistu
if($.cookie('assembliesInWishlist')) {
    var seriesArray = $.cookie('assembliesInWishlist').split('|');
    $('.js_assembly-wishlist-btn').each(function() {
        if(seriesArray.indexOf($(this).data('sourceId').toString()) !== -1) $(this).addClass('active');
    });
}

$(window).resize(function() {
    fixPuSeriesSearch();
});

var fixPuSeriesSearch = function() {
    if($('#seriesSearch').length > 0){
        if(window.innerWidth < 992) {
            $('#seriesSearch')[0].dataset.partialUpdate = "change";
        } else {
            $('#seriesSearch')[0].dataset.partialUpdate = "keyup";
        }
    }
};
fixPuSeriesSearch();

// RWD tables
$('table.table').each(function() {
    $(this).wrap('<div class="table-responsive"></div>');
});

// filtrace produktu podle kategorie v serii
var productCategoriesFilter = function(hash) {
    $('.js_product-categories').each(function () {
        var $container = $(this),
            thisHash = hash || window.location.hash,
            state;

        $container.find('.active').removeClass('active');
        $container.find('.filter-product-group li a').removeClass('active');

        if ((thisHash) && ($container.find(thisHash).length != 0)) {
            $container.find(thisHash).addClass('active');
            $container.find('.filter-product-group li a[href="' + thisHash + '"]').addClass('active');
        }
        else {
            $container.find('.filter-product-group li:first-child a').addClass('active');
            $container.find('.product-list:first').addClass('active');
        }
        if (history && history.replaceState) {
            state = history.state || {};
            state.productCategories = {
                url: window.location.pathname,
                hash: thisHash
            };
            history.replaceState(state, document.title, window.location.pathname + window.location.search + thisHash);
        }
        $container.find('.filter-product-group a').off('click.productCategories').on('click.productCategories',function (e) {
            thisHash = $(this).attr('href');
            e.preventDefault();
            $container.find('.active').removeClass('active');
            $(this).addClass('active');
            $container.find($(this).attr('href')).addClass('active');
            $(this).trigger('EDEESHOP_PRODUCT_LIST_LG_INTERACTIVE_ACTIVATE');
            if (history && history.pushState) {
                state = history.state || {};
                state.productCategories = {
                    url: window.location.pathname,
                    hash: thisHash
                };
                history.pushState(state, document.title, window.location.pathname + window.location.search + thisHash);
            }
        });
    });
};
productCategoriesFilter();

window.onpopstate = function(event) {
    if (history && history.state && history.state.productCategories) {
        productCategoriesFilter(history.state.productCategories.hash);
    }
};


// fulltext
$('.js_toggle-search').click(function() {
    $(this).parent().toggleClass('active');
    $(this).parent().find('input').focus();
});

//Hover obrázek u sérií
$(".catalog-hp-assemblies a").each(function() {
    var src = $(this).data("img");
    var image = '<div><img src="' + src + '"/>';
    $(this).after(image);
    var imageTag = $(this).next("div");
    $(this).hover(
            function () {
                imageTag.addClass("visible");
            },
            function () {
                imageTag.removeClass("visible");
            }
    );
});


// osetreni sirotku pro strankovani
$(document).on('ajaxComplete', function(){
    $('.js_magazine-pagination li').removeClass('hidden');
    if ($('.js_magazine-pagination li.last-page').length < 1) {
        var numOfChildren = $('.js_magazine-pagination li').length;
        if (numOfChildren % 3 != 0) {
            $('.js_magazine-pagination li').eq(-1).addClass('hidden');
            if ((numOfChildren - 1) % 3 != 0) $('.js_magazine-pagination li').eq(-2).addClass('hidden');
        }
    }
});


//file inputs
var inputs = document.querySelectorAll( '.file-input input' );
Array.prototype.forEach.call( inputs, function( input )
{
    var label	 = input.nextElementSibling,
        labelVal = label.querySelector( '.file-input__feedback' ).innerHTML;

    input.addEventListener( 'change', function( e )
    {
        var fileName = '';
        fileName = e.target.value.split( '\\' ).pop();
        if( fileName ) {
            label.querySelector( '.file-input__feedback' ).innerHTML = fileName;
        }
        else {
            label.querySelector( '.file-input__feedback' ).innerHTML = labelVal;
        }
    });
});

//
$('body').on('validationFailed', 'form', function() {
    if($('.has-error', this).size() > 0) {
        /* vypnuti has error pro komponentu Napiste nam */
        if(this.id !== 'contactUsHtmlForm') {
            var errorTopOffset = $('.has-error:first', this).offset().top;
            $('html, body').animate({ scrollTop: errorTopOffset });
        }
    }
});


/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, function(index, f) {
    $(f);
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js